import { ProjectSubType } from '@prisma/client';

export const projectSubTypeTitleByCanonicalSubType: Record<ProjectSubType, string> = {
  [ProjectSubType.GLOBAL_REFORESTATION]: 'Reforestation - Global',
  [ProjectSubType.UK_REFORESTATION]: 'Reforestation - UK',
  [ProjectSubType.US_REFORESTATION]: 'Reforestation - US',
  [ProjectSubType.BRAZIL_REFORESTATION]: 'Reforestation - Brazil',
  [ProjectSubType.AUSTRALIA_REFORESTATION]: 'Reforestation - Australia',
  [ProjectSubType.WIND]: 'Renewables - Wind',
  [ProjectSubType.SOLAR]: 'Renewables - Solar',
  [ProjectSubType.HYDRO]: 'Renewables - Hydro',
  [ProjectSubType.BIOMASS]: 'Renewables - Biomass',
  [ProjectSubType.FOREST_PROTECTION]: 'Forestry - Forest Protection',
};

export const getProjectSubTypeTitle = (projectSubType?: ProjectSubType | null): string | undefined =>
  projectSubType ? projectSubTypeTitleByCanonicalSubType[projectSubType] : undefined;
